import { _ as _assign } from '../tslib.es6-c6da0ae6.js';
import { jsx } from 'react/jsx-runtime';
import { Suspense } from 'react';

function withSuspense(LazyComponent, Fallback) {
  var DeferredComponent = function DeferredComponent(props) {
    return jsx(Suspense, _assign({
      fallback: Fallback ? jsx(Fallback, _assign({}, props)) : null
    }, {
      children: jsx(LazyComponent, _assign({}, props))
    }));
  };
  return DeferredComponent;
}

export { withSuspense as default };
//# sourceMappingURL=index.js.map
